module.exports = __webpack_public_path__ + "static/partner-hxzs-0f0349f203318568891b281bac3a6b86.png";